@let label = (!active() ? 'AI.AINTERACTA' : 'AI.CLOSE_AINTERACTA') | translate;
<span aria-hidden="true" class="ai-glow ai-glow-idle"></span>
<span aria-hidden="true" class="ai-glow ai-glow-interactive"></span>
<button
    class="ai-btn relative flex size-40 items-center justify-center rounded-full hovered-layer pressed-layer transition-button"
    type="button"
    [attr.aria-describedby]="describedBy()"
    [attr.aria-expanded]="active()"
    [attr.aria-label]="label"
    [class.bg-ai-surface]="active()"
    [class.bg-surface-A]="!active()"
    [matTooltip]="label"
    (blur)="isFocusVisible.set(false)"
    (click)="clicked.emit()"
    (focus)="updateFocusVisible($event)"
    (keydown.enter)="startPress()"
    (keydown.space)="startPress()"
>
    <span aria-hidden="true" class="ai-ring ai-ring-idle"></span>
    <span aria-hidden="true" class="ai-ring ai-ring-interactive"></span>
    <span class="ai-logo">
        <interacta-image
            alt=""
            [classes]="'size-full'"
            [loading]="'eager'"
            [src]="logoSrc()"
        />
    </span>
</button>
